<!-- 企业信息 -->
<template>
  <div class="wrapper">
    <el-card class="mr_t">
      <div class="container">
        <div class="container_title">企业信息</div>
        <el-form :model="form" :rules="rules" label-width="400px" ref="form">
          <el-form-item ref="businessLicenseFile" label="上传营业执照" prop="businessLicenseFile">
            <el-upload class="upload-demo" action :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'businessLicenseFile');
                  }
                " :auto-upload="false" :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'businessLicenseFile');
                  }
                " :on-exceed="handleExceed" :file-list="fileList" accept=".jpg,.png">
              <div class="imgBox">
                <div class="imgBody" v-if="!addrList.businessLicenseFileAddr">
                  <i class="el-icon-plus"></i>
                  营业执照
                </div>
                <!-- 上传照片 -->
                <div class="imgfooter" v-if="addrList.businessLicenseFileAddr">
                  <img :src="yyzzUrl" alt="" width="100%" height="100%" />
                  <div class="imgTxt">
                    重新上传
                  </div>
                </div>
              </div>
              <div slot="tip" class="el-upload__tip el_upload_tips1">
                照片信息清晰可见，内容真实有效<br />支持上传格式： .jpg .png<br />上传后系统进行图像识别，请仔细核对识别信息
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="企业名称" prop="customerName">
            <el-input clearable v-model="form.customerName" placeholder="请输入企业名称">
            </el-input>
          </el-form-item>
          <el-form-item label="社会统一信用代码" prop="creditCode">
            <!-- oninput="value=value.replace(/[^0-9A-Z]/g,'');" @blur="form.creditCode= $event.target.value" -->
            <el-input clearable v-model="form.creditCode" placeholder="请输入社会统一信用代码">
            </el-input>
          </el-form-item>
          <el-form-item label="注册资本（万元）" prop="registerCapital">
            <el-input-number clearable :controls="false" v-model="form.registerCapital" :min="0" :max="999999" placeholder="请输入注册资本">
            </el-input-number>
          </el-form-item>
          <el-form-item label="成立日期" prop="registerDate">
            <el-date-picker value-format="yyyy-MM-dd" v-model="form.registerDate" type="date" placeholder="请选择成立日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="营业期限" prop="registerDatetype">
            <el-select clearable v-model="form.registerDatetype">
              <el-option v-for="item in registerDateTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="营业起始日期" prop="registerDateStart">
            <el-date-picker style="width: 240px" v-model="form.registerDateStart" value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="营业截止日期" prop="registerDateEnd" v-if="form.registerDatetype == 2">
            <el-date-picker style="width: 240px" v-model="form.registerDateEnd" value-format="yyyy-MM-dd" placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="企业注册地址" prop="address">
            <el-cascader style="width:24%;" placeholder="省份-城市" v-model="cityValue" :options="options" :props="{ expandTrigger: 'hover' }" @change="cityChange">
            </el-cascader>
            <el-input style="width:72%;margin-left:20px;" clearable v-model="form.address" placeholder="请输入企业注册地址">
            </el-input>
          </el-form-item>
          <el-form-item label="选择公司性质" prop="companyType">
            <el-select clearable v-model="form.companyType">
              <el-option v-for="item in companyTypeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联母公司名称" prop="mentorName" v-if="form.companyType == 2">
            <el-select clearable v-model="form.mentorName" filterable>
              <el-option v-for="item in customerList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item ref="mentorProveFile" label="关联母公司证明材料" prop="mentorProveFile" v-if="form.companyType == 2">
            <el-upload class="upload-demo" style="width: 400px" action :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'mentorProveFile');
                  }
                " :auto-upload="false" :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'mentorProveFile');
                  }
                " :on-exceed="handleExceed" :file-list="mentorProveFileFileList" accept=".doc,.docx,.pdf,.jpg,.png">
              <div class="imgBox">
                <div class="imgBody" v-if="!addrList.mentorProveFileAddr">
                  <i class="el-icon-plus"></i>
                  证明材料
                </div>
                <!-- 上传照片 -->
                <div class="imgfooter" v-if="addrList.mentorProveFileAddr">
                  <img :src="yyzzUrl" alt="" width="100%" height="100%" />
                  <!-- <i class="el-icon-plus"></i> -->
                  <div class="imgTxt">
                    重新上传
                  </div>
                </div>
              </div>
              <div slot="tip" class="el-upload__tip el_upload_tips1" style="top:40px;">
                支持上传格式：.doc .docx .pdf .jpg .png
              </div>
            </el-upload>
          </el-form-item>
          <el-divider></el-divider>
          <div class="container_title mr_t">法人信息</div>
          <div>
            <div class="radio_item">
              <el-form-item label="法人与账户注册人为同一人" prop="registerPersonFlag">
                <el-radio-group v-model="form.registerPersonFlag" @change="radioChange">
                  <el-radio :label="1">
                    是
                  </el-radio>
                  <el-radio :label="0">
                    否
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
            <div v-if="form.registerPersonFlag == 1">
              <el-form-item label="法人姓名：" prop="corporaName">
                {{ customerDetail.contactName }}
              </el-form-item>
              <el-form-item label="法人身份证号：" prop="corporaIdNumber">
                <table-column-decrypt  :key="Math.random()" class="value" :decrypt-dto="customerDetail.contractIdNumberDto" :src-value="customerDetail.contractIdNumber" />
              </el-form-item>
              <el-form-item label="法人手机号：" prop="corporaPhone">
                <table-column-decrypt  :key="Math.random()" class="value" :decrypt-dto="customerDetail.contactPhoneDto" :src-value="customerDetail.contactPhone" />
              </el-form-item>
            </div>
            <div v-if="form.registerPersonFlag == 0">
              <el-form-item ref="corporaFile" label="上传法人身份证" prop="corporaFile">
                <div class="imgWrapper">
                  <el-upload class="upload-demo" action :on-preview="handlePreview" :on-remove="(file, fileList) => {handleRemove(file, fileList, 'corporaFile');}" :auto-upload="false" :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'corporaFile');
                  }
                " :on-exceed="handleExceed" :file-list="corporaFileFileList" accept=".jpg,.png">
                    <div class="imgBox">
                      <div class="imgBody" v-if="!addrList.corporaFileAddress">
                        <i class="el-icon-plus"></i>
                        头像页
                      </div>
                      <div class="imgfooter" v-if="addrList.corporaFileAddress">
                        <img :src="frsfzUrl" alt="" width="100%" height="100%" />
                        <div class="imgTxt">
                          重新上传
                        </div>
                      </div>
                    </div>
                  </el-upload>
                  <el-upload class="upload-demo" action :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'idCarBFile');
                  }
                " :auto-upload="false" :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'idCarBFile');
                  }
                " :on-exceed="handleExceed" :file-list="idCarBFileFileList" accept=".jpg,.png">
                    <div class="imgBox" style="margin-left:20px">
                      <div class="imgBody" v-if="!addrList.idCarBFileAddr">
                        <i class="el-icon-plus"></i>
                        国徽页
                      </div>
                      <div class="imgfooter" v-if="addrList.idCarBFileAddr">
                        <img :src="frsfzfmUrl" alt="" width="100%" height="100%" />
                        <div class="imgTxt">
                          重新上传
                        </div>
                      </div>
                    </div>
                  </el-upload>
                  <div slot="tip" class="el-upload__tip" style="margin-left:20px;margin-top: 40px !important;">
                    照片信息清晰可见，内容真实有效<br />支持上传格式： .jpg .png
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="法人姓名" prop="corporaName">
                <el-input show-word-limit minlength="2" maxlength="4" clearable v-model="form.corporaName">
                </el-input>
              </el-form-item>
              <el-form-item label="法人身份证号码" prop="corporaIdNumber">
                <el-input show-word-limit maxlength="18" clearable v-model="form.corporaIdNumber">
                </el-input>
              </el-form-item>
              <el-form-item label="手机号码" prop="corporaPhone">
                <el-input clearable v-model.number="form.corporaPhone">
                </el-input>
              </el-form-item>
              <el-form-item ref="attorneyFile" label="上传法人授权委托书" prop="attorneyFile">
                <el-upload class="upload-demo" action :auto-upload="false" :on-preview="handlePreview" :on-remove="
                  (file, fileList) => {
                    handleRemove(file, fileList, 'attorneyFile');
                  }
                " :on-change="
                  (file, fileList) => {
                    handleChange(file, fileList, 'attorneyFile');
                  }
                " :on-exceed="handleExceed" :file-list="attorneyFileFileList">

                  <div class="imgBox">
                    <div class="imgBody" v-if="!addrList.attorneyFileAddress">
                      <i class="el-icon-plus"></i>
                      授权委托书
                    </div>
                    <!-- 上传照片 -->
                    <div class="imgfooter" v-if="addrList.attorneyFileAddress">
                      <img :src="yyzzUrl" alt="" width="100%" height="100%" />
                      <!-- <i class="el-icon-plus"></i> -->
                      <div class="imgTxt">
                        重新上传
                      </div>
                    </div>
                  </div>
                  <div slot="tip" class="el-upload__tip el_upload_tips1" style="top:4px">
                    支持上传格式：.doc .docx .pdf .jpg .png <br />注：需上传法人授权委托书，请按模版填写盖章后上传<br />
                    <a @click="downLoadTpl('法人授权委托函.docx')" style="cursor: pointer;"><img src="@/assets/download2.png" class="download_img" align="absbottom">下载模版</a>
                  </div>
                </el-upload>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </el-card>
    <el-card class="mr_t">
      <div class="btn">
        <el-button @click="save(1)">保存</el-button>
        <!-- <el-button type="primary" @click="jumpStep">下一步</el-button> -->
        <el-button type="primary" @click="submit">提交</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import getMvcUrl from "../../../utils/mvcUrlUtil.js";
import { formatDate } from "@/common/js/date.js";
import { mapActions } from "vuex";
import fetchPost from "@/api/http.js";
import moment from "moment";
import { decrypt } from "@/api/util"
import tableColumnDecrypt from '@/components/table-column-decrypt.vue';
export default {
  components: {
    tableColumnDecrypt
  },
  data() {
    var _this = this;
    const getRule = (FileList, addrItem, text) => {
      return (rule, _value, callback) => {
        if (_this[FileList].length == "0" && !this.addrList[addrItem]) {
          return callback(new Error(text));
        } else {
          callback();
        }
      }
    }
    const corporaFileValidate = (rule, value, callback) => {
      if (this.corporaFileFileList.length == "0" && !this.addrList.corporaFileAddress) {
        callback(new Error("请上传法人身份证头像页"));
      } else if (this.idCarBFileFileList.length == "0" && !this.addrList.idCarBFileAddr) {
        callback(new Error("请上传法人身份证国徽页"));
      } else {
        callback();
      }
    };
    const validCorporaName = (rule, value, callback) => {
      //console.log(value)
      if (!value) {
        return callback(new Error("请输入法人姓名"));
      } else if (value.length < 2 || value.length > 4) {
        return callback(new Error("请输入2-4个汉字"));
      } else {
        callback();
      }
    };
    const validIdCard = (rule, value, callback) => {
      let msr =
        /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
      if (!msr.test(value)) {
        callback(new Error("请输入正确的18位身份证号码"));
      } else {
        callback();
      }
    };
    const checkPhoneNum = (rule, value, callback) => {
      if (!value && value !== 0) {
        return callback(new Error("手机号码不能为空"));
      }
      if (!Number.isInteger(parseInt(value))) {
        callback(new Error("请输入数字值"));
      } else {
        var myreg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(value)) {
          callback(new Error("手机号码输入有误"));
        } else {
          callback();
        }
      }
    };
    const addressValidate = (rule, value, callback) => {
      if (this.cityValue && this.cityValue.length != 2) {
        callback(new Error("请选择省份-城市"));
      } else if (!value) {
        callback(new Error("请输入企业注册地址"));
      } else {
        callback();
      }
    };
    return {
      active: 1,
      form: {
        customerNo: JSON.parse(sessionStorage.getItem("userInfo")).customerNo,
        customerName: "",
        address: "",
        creditCode: "",
        registerCapital: undefined,
        registerDate: "",
        registerDateStart: "",
        registerDateEnd: "",
        companyType: "",
        mentorName: "",
        corporaName: "",
        corporaIdNumber: "",
        corporaPhone: "",
        contactName: "",
        contactPhone: "",
        contractIdNumber: "",
        provinceCode: "",
        cityCode: "",
        bankName: "",
        banka: "",
        bankAccount: "",
        registerPersonFlag: "",
        provinceName: "",
        cityName: "",
        businessLicenseFileAddr: "",
        corporaFileAddress: "",
        idCarBFileAddr: "",
        attorneyFileAddress: "",
        mentorProveFileAddr: "",
        registerDatetype: ""
      },
      rules: {
        businessLicenseFile: [
          {
            required: true,
            validator: getRule('fileList', 'businessLicenseFileAddr', '请上传营业执照'),
            trigger: "blur",
          },
        ],
        customerName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        address: [
          { required: true, validator: addressValidate, trigger: "blur" },
        ],
        creditCode: [
          {
            required: true,
            message: "请输入社会统一信用代码",
            trigger: "blur",
          },
        ],
        registerCapital: [
          {
            required: true,
            message: "请输入注册资本（万元）",
            trigger: "blur",
          },
        ],
        registerDate: [
          { required: true, message: "请选择成立日期", trigger: "change" },
        ],
        registerDatetype: [
          { required: true, message: "请选择营业期限", trigger: "change" },
        ],
        registerDateStart: [
          { required: true, message: "请选择营业起始日期", trigger: "change" },
        ],
        registerDateEnd: [
          { required: true, message: "请选择营业截止日期", trigger: "change" },
        ],
        companyType: [
          { required: true, message: "请选择公司性质", trigger: "change" },
        ],
        mentorName: [
          {
            required: true,
            message: "请选择关联母公司名称",
            trigger: "change",
          },
        ],
        mentorProveFile: [
          {
            required: true,
            validator: getRule('mentorProveFileFileList', 'mentorProveFileAddr', '请上传关联母公司证明材料'),
            trigger: "change",
          },
        ],
        corporaFile: [
          { required: true, validator: corporaFileValidate, trigger: "change" },
        ],
        corporaName: [
          { required: true, validator: validCorporaName, trigger: "blur" },
        ],
        corporaIdNumber: [
          { required: true, validator: validIdCard, trigger: "blur" },
        ],
        corporaPhone: [
          { required: true, validator: checkPhoneNum, trigger: "blur" },
        ],
        attorneyFile: [
          {
            required: true,
            validator: getRule('attorneyFileFileList', 'attorneyFileAddress', '请上传法人授权委托书'),
            trigger: "change",
          },
        ],
        registerPersonFlag: [
          { required: true, message: "请选择法人与账户注册人是否为同一人", trigger: "change" },
        ],
      },
      fileList: [],
      addrList: {
        businessLicenseFileAddr: "", //营业执照存储地址
        contractFileAddress: "", //联系人身份证件地址
        corporaIdCarBFileAddr: "", //联系人身份证件反面地址
        attorneyFileAddress: "", //委托书存储地址
        mentorProveFileAddr: "", //母公司证明材料
        accountOpeningFileAddr: "", //开户许可证文件
        corporaFileAddress: "", //法人身份证件地址
        idCarBFileAddr: "", //法人身份证件反面
      },
      cityValue: [],
      options: [],
      registerDateTypeList: [
        {
          value: "1",
          label: "长期",
        },
        {
          value: "2",
          label: "选择",
        },
      ],
      companyTypeList: [
        {
          value: 1,
          label: "母公司",
        },
        {
          value: 2,
          label: "子公司",
        },
      ],
      mentorProveFileFileList: [],
      customerList: [],
      corporaFileFileList: [],
      idCarBFileFileList: [],
      fileArr: [
        { fileName: 'businessLicenseFile', listName: 'fileList' },
        { fileName: 'mentorProveFile', listName: 'mentorProveFileFileList' },
        { fileName: 'corporaFile', listName: 'corporaFileFileList', type: 'idCard' },
        { fileName: 'idCarBFile', listName: 'idCarBFileFileList', type: 'idCard' },
        { fileName: 'contractFile', listName: 'contractFileFileList', type: 'lxrCard' },
        { fileName: 'corporaIdCarBFile', listName: 'corporaIdCarBFileList', type: 'lxrCard' },
        { fileName: 'attorneyFile', listName: 'attorneyFileFileList' },
      ],
      attorneyFileFileList: [],
      lxrDisabled: false,
      customerDetail: "",
      formCopy: {},
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      lxrSfzUrl: "",
      lxrsfzfmUrl: "",
      frsfzUrl: "",
      frsfzfmUrl: "",
      khxkzUrl: "",
      yyzzUrl: "",
      imgBaseUrl: "",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date("1970-01-01").getTime();//不能选择1970年之前的日期
        }
      }
    }
  },
  mounted() {
    this.initCity();
    this.formData = new window.FormData();
    this.getAllCustomer();
    this.imgBaseUrl = getMvcUrl() + "/saas/companyQualification/viewImage?objectName=";
  },
  watch: {
    'form.registerDatetype': function (val) {
      if (val == 1) {
        this.form.registerDateEnd = '';
      }
    },
    'form.companyType': function (val) {
      if (val == 1) {
        this.form.mentorName = '';
        this.mentorProveFileFileList = [];
        this.addrList.mentorProveFileAddr = '';
        this.yyzzUrl = '';
      }
    },
  },
  methods: {
    ...mapActions([
      "listAllCitys",
      "businessAuthenticationSubmitDraftForSaasApi",
      "businessAuthenticationForSaasApi",
      "queryByCustomerNoAPI",
      "businessLicenseApi",
      "queryAllMentorConpany"
    ]),
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) { },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleChange(file, fileList, val) {
      let size = Number(file.size / 1024 / 1024);
      let pass;
      if (size > 5) {
        this.$message.warning('文件大小不能超过5MB，请重新上传');
        pass = false;
      } else {
        pass = true;
      }
      this.fileArr.forEach(item => {
        if (item.fileName == val) {
          this[item.listName] = [];
          if (pass) {
            this[item.listName] = [];
            this[item.listName].push(file);
          } else {
            this.formData.delete(item.fileName);
          }
          this.formData.delete(item.fileName);
          this.formData.append(item.fileName, file.raw);
          if (item.type == 'idCard') {
            this.$refs.corporaFile.clearValidate();
          } else if (item.type == 'lxrCard') {
            this.$refs.contractFile.clearValidate();
          } else {
            this.$refs[item.fileName].clearValidate();
          }
          if (val == 'businessLicenseFile') {
            this.businessLicense(file.raw);
          }
          if (val == 'corporaFile' || val == 'idCarBFile') {
            let idCardSide = "";
            if (val == 'corporaFile') {
              idCardSide = "front";
            } else if (val == 'idCarBFile') {
              idCardSide = "back";
            }
            this.ocrDistinguish(idCardSide, file.raw);
          }
        }
      })
    },
    handleRemove(file, fileList, val) {
      this.fileArr.forEach(item => {
        if (item.fileName == val) {
          this[item.listName] = [];
          this.formData.delete(item.fileName)
        }
      })
    },
    businessLicense(file) {
      this.formData.delete("file");
      this.formData.append("file", file);
      this.businessLicenseApi(this.formData).then((res) => {
        if (res) {
          //console.log(res);
          this.addrList.businessLicenseFileAddr = res.imgPath;
          this.yyzzUrl = this.imgBaseUrl + res.imgPath;
          this.form.customerName = res.imgInfo.name;
          this.form.creditCode = res.imgInfo.num;
          if (res.imgInfo.captial && res.imgInfo.captial != "无") {
            this.form.registerCapital = parseInt(res.imgInfo.captial);
          }
          this.form.address = res.imgInfo.addr;
          if (res.imgInfo.date && res.imgInfo.date != "年月日" &&res.imgInfo.date.length == 11) {
            this.form.registerDate = this.getData(res.imgInfo.date);
            this.form.registerDateStart = this.getData(res.imgInfo.date);
          }
          if (res.imgInfo.timeRange && res.imgInfo.timeRange != "无" && res.imgInfo.timeRange != "年月日") {
            this.form.registerDateEnd = this.getData(res.imgInfo.timeRange);
          }
          if (res.imgInfo.timeRange) {
            if (res.imgInfo.timeRange == "长期") {
              this.form.registerDateEnd = "";
              this.form.registerDatetype = "1";
            } else if (res.imgInfo.timeRange != "无" && res.imgInfo.timeRange != "年月日") {
              let registerDateEnd = this.getData(res.imgInfo.timeRange);
              if (moment(new Date(registerDateEnd)) < moment(new Date())) {
                this.$message({
                  type: "error",
                  message: "营业执照已过有效期限",
                });
                return;
              }
              this.form.registerDateEnd = this.getData(res.imgInfo.timeRange);
              if (this.getData(res.imgInfo.timeRange)) {
                this.form.registerDatetype = "2";
              }
            }
          }
        }
      });
    },
    getData(val, type) {
      if (val) {
        if (type && type == 1) {
          let year = val.slice(0, 4);
          let month = val.slice(4, 6);
          let date = val.slice(6, 8);
          return year + "-" + month + "-" + date
        } else {
          let year = val.slice(0, 4);
          let month = val.slice(5, 7);
          let date = val.slice(8, 10);
          return year + "-" + month + "-" + date
        }
      }
    },
    ocrDistinguish(idCardSide, file) {
      this.formData.delete("file");
      this.formData.append("file", file);
      fetchPost("/saas/ocr/idCard/" + idCardSide, this.formData)
        .then(
          res => {
            if (res.imgInfo.imageStatus == "other_type_card") {
              this.$message({
                type: "error",
                message: "请上传正确的身份证件",
              });
              return;
            }
            if (idCardSide == "front") {
              this.addrList.corporaFileAddress = res.imgPath;
              this.frsfzUrl = this.imgBaseUrl + res.imgPath;
              this.form.corporaName = res.imgInfo.name;
              this.form.corporaIdNumber = res.imgInfo.idNo;
            } else {
              this.addrList.idCarBFileAddr = res.imgPath;
              this.frsfzfmUrl = this.imgBaseUrl + res.imgPath;
            }
            if (res.imgInfo.expiryDate) {
              let expiryDate = this.getData(res.imgInfo.expiryDate, 1);
              if (moment(new Date(expiryDate)) < moment(new Date())) {
                this.$message({
                  type: "error",
                  message: "身份证已过有效期限",
                });
                return;
              }
            }
          }
        );
    },
    radioChange(val){
      //联系人就是实名认证中的联系人
      this.form.contactName = this.formCopy.contactName;
      this.form.contractIdNumber = this.formCopy.contractIdNumber;
      this.form.contactPhone = this.formCopy.contactPhone;
      //如果法人与账户注册人为同一人则法人就是联系人，否则法人信息为空，补充填写法人信息
      if (val == 1) {
        this.form.corporaName = this.formCopy.contactName;
        this.form.corporaIdNumber = this.formCopy.contractIdNumber;
        this.form.corporaPhone = this.formCopy.contactPhone;
        this.form.corporaFileAddress = this.formCopy.contractFileAddress;
        this.form.idCarBFileAddr = this.formCopy.corporaIdCarBFileAddr;
        this.form.attorneyFileAddress = '';
        this.addrList.corporaFileAddress = this.form.corporaFileAddress;
        this.addrList.idCarBFileAddr = this.form.idCarBFileAddr;
        this.addrList.attorneyFileAddress = '';
        this.frsfzUrl = '';
        this.frsfzfmUrl = '';
        this.yyzzUrl = '';
        this.corporaFileFileList = [];
        this.idCarBFileFileList = [];
      }else {
        this.form.corporaName = "";
        this.form.corporaIdNumber = "";
        this.form.corporaPhone = "";
        this.form.corporaFileAddress = '';
        this.form.idCarBFileAddr = '';
        this.addrList.corporaFileAddress = '';
        this.addrList.idCarBFileAddr = '';
      }
    },
    cityChange(val) {
      console.log(val)
      if (val.length > 0) {
        this.form.provinceCode = val[0];
        this.form.cityCode = val[1];
        let cityList = [];
        this.options.forEach(item => {
          cityList.push(item.children)
          item.children.forEach(el => {
            cityList.push(el)
          })
        })
        let cityObj = cityList.find(item => {
          return item.value == this.form.cityCode
        })
        let provinceObj = this.options.find(item => {
          return item.value == this.form.provinceCode
        })
        this.form.provinceName = provinceObj.label;
        this.form.cityName = cityObj.label;
      }
    },
    initCity() {
      this.listAllCitys({}).then(res => {
        let { obj } = res
        let arr = obj.map(item => {
          return {
            value: item.code,
            label: item.name,
            children: item.cityList.map(el => {
              return {
                value: el.code,
                label: el.name,
              }
            })
          }
        })
        this.options = arr;
      })
    },
    getAllCustomer() {
      this.queryAllMentorConpany({}).then(res => {
        if (res) {
          this.customerList = res.customers.map((item) => {
            return {
              value: item.customerNo,
              label: item.customerName,
            };
          });
          sessionStorage.setItem('customerList', JSON.stringify(this.customerList))
          this.queryByCustomerNo();
        }
      },
        (res) => {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      );
    },
    downLoadTpl(tplName) {
      let preUrl = getMvcUrl() + '/saas/downLoad/downLoadTpl?tplName=' + tplName;
      window.open(preUrl);
    },
    getParams() {
      let params = JSON.parse(JSON.stringify(this.form));
      if (this.form.registerDatetype == 1) {
        this.form.registerDateEnd = "";
      }
      return params;
    },
    jumpStep() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.registerDatetype == 2 && moment(new Date(this.form.registerDateEnd)) < moment(new Date())) {
            this.$message({
              type: "error",
              message: "营业执照已过有效期限",
            });
            return;
          }
          // this.save(2);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    save(type) {
      // 保存  提交草稿       
      let params = this.getParams();
      this.formData.delete("param");
      this.formData.append("param", JSON.stringify(params));
      this.businessAuthenticationSubmitDraftForSaasApi(this.formData).then((res) => {
        if (res) {
          //console.log(res);
          if (type == 1) {
            this.$message.success("保存成功");
          } else {
            this.$emit("jumpStep", 2);
          }
        }
      });
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = this.getParams();
          this.formData.delete("param");
          this.formData.append("param", JSON.stringify(params));
          this.$nextTick(() => {
            this.businessAuthenticationForSaasApi(this.formData).then((res) => {
              if (res) {
                this.$message.success("提交成功");
                this.$emit("jumpStep", 3);//跳转审核
              }
            });
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    queryByCustomerNo() {
      // 进入页面回显相关信息
      let params = {
        customerNo: this.form.customerNo,
      };
      this.queryByCustomerNoAPI(params).then(async(res) => {
        let { customerDetail, historyList } = res;
        //this.status = customerDetail.status;
        this.customerDetail = customerDetail;
        this.rejeactCause = historyList[0].updateResult;
        this.status = customerDetail.status;
        if (this.status == 6 || this.status == 7) {
          this.$refs['form'].resetFields();
        }
        const decryptProps = []
        for (let key in this.form) {
          if (key != "yyqx") {
            this.form[key] = customerDetail[key];
            if (customerDetail[`${key}Dto`]){
              decryptProps.push(key)
            }
          }
        }
        if (customerDetail.mentorName) {
          let obj = this.customerList.find((item) => {
            return item.label == customerDetail.mentorName;
          });
          this.form.mentorName = obj.value;
        }
        for (let key in this.addrList) {
          this.addrList[key] = customerDetail[key];
          this.form[key] = customerDetail[key];
          if (customerDetail[`${key}Dto`]){
              decryptProps.push(key)
            }
        }
        
        if (this.form.registerPersonFlag === '0' || this.form.registerPersonFlag === '1') {
          this.form.registerPersonFlag = + this.form.registerPersonFlag;
        } else {
          this.form.registerPersonFlag = 1;
          this.form.corporaName = this.form.contactName;
          this.form.corporaIdNumber = this.form.contractIdNumber;
          this.form.corporaPhone = this.form.contactPhone;
        }
        if (this.customerDetail.registerDateType) {
          this.form.registerDatetype = this.customerDetail.registerDateType;
        }
        
        this.fileBaseUrl =
          getMvcUrl() + "/saas/companyQualification/downLoadFile?objectName=";
        this.yyzzUrl = this.imgBaseUrl + this.addrList.businessLicenseFileAddr;
        this.frsfzUrl = this.imgBaseUrl + this.addrList.corporaFileAddress;
        this.frsfzfmUrl = this.imgBaseUrl + this.addrList.idCarBFileAddr;
        this.khxkzUrl = this.imgBaseUrl + this.addrList.accountOpeningFileAddr;
        this.lxrSfzUrl = this.imgBaseUrl + this.addrList.contractFileAddress;
        this.lxrsfzfmUrl = this.imgBaseUrl + this.addrList.corporaIdCarBFileAddr;
        if (!this.customerDetail.registerCapital) {
          this.form.registerCapital = undefined;
        }
        if (this.form.registerDate) {
          this.form.registerDate = formatDate(
            new Date(this.form.registerDateStart),
            "yyyy-MM-dd"
          );
        } else {
          this.form.registerDate = "";
        }
        if (this.form.registerDateStart) {
          this.form.registerDateStart = formatDate(
            new Date(this.form.registerDateStart),
            "yyyy-MM-dd"
          );
        } else {
          this.form.registerDateStart = "";
        }
        if (this.form.registerDateEnd) {
          this.form.registerDateEnd = formatDate(
            new Date(this.form.registerDateEnd),
            "yyyy-MM-dd"
          );
        } else {
          this.form.registerDateEnd = "";
        }
        if (!this.form.registerDatetype) {
          this.form.registerDatetype = "";
        }
        if (!this.form.companyType) {
          this.form.companyType = "";
        }
        if (this.form.registerPersonFlag === 1) {
          this.form.corporaPhone = this.userInfo.telephone;
        }
        if (this.form.registerPersonFlag === 0) {
          this.form.contactPhone = this.userInfo.telephone;
        }
        if (this.form.provinceCode && this.form.cityCode) {
          this.cityValue = [this.form.provinceCode, this.form.cityCode];
        }
        // 解密
        if (decryptProps.length > 0) {
          const decryptAll = () => {
            return new Promise((resolve, reject) => {
              decryptProps.forEach( async(prop, index) => {
                const decryptValue = await decrypt(customerDetail[`${prop}Dto`].encStr)
                this.form[prop] = decryptValue
                if (index === decryptProps.length -1) {
                  resolve(true)
                }
              })
            }) 
          }
          await decryptAll()
        }
        this.formCopy = JSON.parse(JSON.stringify(this.form))
      });
    },
    setCityAttr() {
      let cityList = [];
      this.options.forEach(item => {
        cityList.push(item.children)
        item.children.forEach(el => {
          cityList.push(el)
        })
      })
      //console.log(cityList)
      let cityObj = cityList.find(item => {
        return item.value == this.form.cityCode
      })
      let provinceObj = this.options.find(item => {
        return item.value == this.form.provinceCode
      })
      if (provinceObj && cityObj)
        this.form.address = provinceObj.label + cityObj.label + this.form.address
    },
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-form-item__content {
  width: 600px !important;
}
/deep/ .el-form-item {
  margin-bottom: 22px !important;
}
/deep/ .el-upload-list__item-name {
  width: 98px;
  margin-right: 0 !important;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner,
.el-select,
/deep/ .el-input-number {
  width: 100% !important;
}
/deep/ .el-input__inner {
  text-align: left !important;
}
/deep/ .el-date-editor .el-range__icon {
  margin-left: 4px;
}
.radio_item /deep/ .el-form-item {
  margin-bottom: 20px !important;
}
.wrapper {
  .mr_t {
    margin-top: 24px !important;
  }
  .container {
    padding: 24px 32px !important;
    .container_title {
      margin-bottom: 24px !important;
    }
    .imgBox {
      width: 80px;
      height: 80px;
      background: rgba(0, 0, 0, 0.02);
      border: 0.8px dashed rgba(0, 0, 0, 0.15);
      border-radius: 3px;
      position: relative;
      display: inline-block;
      .imgBody {
        width: 100%;
        height: 100%;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        line-height: 17.63px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-icon-plus {
          width: 20px;
          height: 20px;
        }
      }
      .imgfooter {
        width: 100%;
        height: 100%;
        background-color: #f5f5f5;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .imgTxt {
          position: absolute;
          height: 30px;
          line-height: 30px;
          bottom: 0;
          left: 0;
          width: 100%;
          text-align: center;
          background: rgba(0, 0, 0, 0.5);
          color: #fff;
        }
      }
    }
    .el-upload__tip {
      line-height: 20px;
      margin-top: 20px !important;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
      font-weight: 400;
    }
    .el_upload_tips1 {
      position: absolute;
      top: 4px;
      left: 100px;
    }
  }
  .btn {
    padding: 24px 32px !important;
    text-align: right;
  }
  .imgWrapper {
    display: flex;
  }
  .download_img {
    width: 16px;
    height: 16px;
    margin-bottom: 2px !important;
  }
}
</style>